// checks if the loaded window context is embedded inside an iframe
export const instanceIsInIframe = (() => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
})();
